module.exports = __webpack_public_path__ + "img/heatex-S-idle.d6a1ce2c.png";